import { render, staticRenderFns } from "./role-editor.vue?vue&type=template&id=4e870cae&scoped=true&"
import script from "./role-editor.vue?vue&type=script&lang=js&"
export * from "./role-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e870cae",
  null
  
)

export default component.exports